// @flow
import styled from 'styled-components';
import { expandFadeOut } from '~/core/constants/animations';

export const BoostRingsContainer = styled.div`
    position: relative;
    user-select: none;
`;

export const BoostRingsInner = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;
`;

export const BoostRingsInnerInner = styled.div`
    position: relative;
    display: inline-block;
    line-height: 0;
    width: 100%;
    margin: 0;
    padding: 0;
`;

export const BoostRingsList = styled.div`
    margin: 0;
    padding: 0 0 100%;
    width: 100%;
`;

const BoostRingsRing = styled.div`
    position: absolute;
    display: block;
    width: 120%;
    height: 120%;
    top: -10%;
    left: -10%;
    border: 1px solid;
    border-color: ${props => (props.mode === 'cool' ? props.theme.coldTempBlue : props.theme.mainBrandColor)};
    background-color: transparent;
    border-radius: 50%;
    opacity: 0;
    box-sizing: content-box;
    animation: 4s ${expandFadeOut} infinite linear;
`;

export const BoostRingsRing1 = BoostRingsRing.extend`animation-delay: 0;`;

export const BoostRingsRing2 = BoostRingsRing.extend`animation-delay: 1s;`;

export const BoostRingsRing3 = BoostRingsRing.extend`animation-delay: 2s;`;

export const BoostRingsRing4 = BoostRingsRing.extend`animation-delay: 3s;`;



// WEBPACK FOOTER //
// ./src/components/widgets/boost-rings/styles.js